function chgStempedContent(act, t) {
  StampedWidgetFullPageFn.changeType(act);
  $('.stamped-full-page-tabs-li').removeClass('active');
  // console.log(t);
  // console.log($(t).parent('li'));
  $(t).parent('li').addClass('active');
}
// dom ready
window.addEventListener('DOMContentLoaded', function() {
  $('.large--two-thirds').css('width', '100%');
  $('.push--large--one-sixth').css('left', '0%');
});
